import React, {PureComponent} from 'react';
import {getLinkPath, scrollToTop} from 'app/utils';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';

export default class StubSport extends PureComponent {
    render(): React.ReactNode {
        return <div className="wrapper-stub">
            <div className="inner-stub">
                <span className="stub-icon stub-icon--sport"/>
                <h1>{I18n.t('stub_sport.title')}</h1>
                <div className="stub-text">
                    <p>{I18n.t('stub_sport.text_1')}</p>
                    <p>{I18n.t('stub_sport.text_2')} <Link
                        to={getLinkPath('/play/bets')}
                        onClick={scrollToTop}
                    >
                        {I18n.t('stub_sport.text_3')}
                    </Link>.</p>
                    <p>{I18n.t('stub_sport.text_4')}</p>
                </div>
            </div>
        </div>;
    }
}
